var _path, _path2, _path3, _path4, _circle, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8823 21.8277C19.7647 10.554 63.1516 12.2624 68.6176 21.8277L50.5113 40.2757H34.7964L10.8823 21.8277Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1945 50.1834C42.3074 52.3577 37.4637 52.2371 28.9886 50.1834L25.2307 49.1585C26.825 44.8312 30.2666 35.9181 30.3551 36.1766C30.7563 37.3478 42.9197 37.5904 48.8031 36.1766L51.1945 50.1834Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7398 65.8975L37.5294 36.8591C26.1925 31.974 20.2698 28.766 10.8824 21.8274C6.96313 28.6592 5.06915 33.4521 2 43.0084C7.05562 55.9548 10.965 60.3092 18.7398 65.8975Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7602 65.8975L41.9706 36.8591C53.3075 31.974 60.4186 29.6849 68.6176 21.8274C72.5369 28.6592 74.4309 33.4521 77.5 43.0084C72.4444 55.9548 68.535 60.3092 60.7602 65.8975Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1189,
    cy: 45.7246,
    r: 1.21336,
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5276 33.4932C38.1145 31.7308 42.3221 31.8034 49.71 33.4932",
    stroke: "#333333",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollar);
export default __webpack_public_path__ + "static/media/collar.1dc90e95c30ed3fb35c6172c32ab965a.svg";
export { ForwardRef as ReactComponent };